module.exports = __webpack_public_path__ + "static/media/VendingPlaceholderImage.18184631.png";